import Box from '@mui/material/Box'
import Button from '@mui/material/Button'
import PropTypes from 'prop-types'
import React from 'react'
import { Link as RouterLink } from 'react-router-dom'

import Icon from './icon'

const InternalButton = ({ children, ...props }) => (
  <Button {...props} component={RouterLink}>
    {children}
  </Button>
)

InternalButton.propTypes = {
  children: PropTypes.node.isRequired,
}

Button.Internal = InternalButton

const DownloadButton = ({ children, url, onClick }) => (
  <Box mt={1}>
    <Button variant="outlined" href={url} download size="small" onClick={onClick}>
      {children}
      <Box ml="5px" mt="3px">
        <Icon name="download" size="md" />
      </Box>
    </Button>
  </Box>
)

DownloadButton.propTypes = {
  children: PropTypes.node.isRequired,
  url: PropTypes.string,
  onClick: PropTypes.func,
}

DownloadButton.defaultProps = {
  url: null,
  onClick: null,
}

Button.Download = DownloadButton

export default Button
